// extracted by mini-css-extract-plugin
export default {"registration":"css_registration__1ALmK"};